<template>

<div>
    <f-title title="Liftguardian" class="mt-5">
        <template v-slot:right>
            <div class="v-flex"  v-if="site.deviceLGSmart ">
                <div
                    class="lgs-status-chip white--text primary mr-1"
                >
                    aktiv
                </div>

                <div
                    v-if="site.lgSmart && site.lgSmart.troubleshooting && site.lgSmart.troubleshooting.length > 0 "
                >
                    <v-menu
                        bottom
                        nudge-bottom="22"
                        :close-on-click="true"
                        min-width="300"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <a
                                v-bind="attrs"
                                v-on="on"
                            >
                                <div style="width: 50px; height: 21px; border-radius: 4px; text-align: center" class="warning">
                                    <v-icon color="white" size="16" style="margin-top: -4px">mdi-wrench</v-icon>
                                </div>
                            </a>
                        </template>
                        <div class="white">
                            <div class="warning white--text pa-1 pl-2" style="font-size: 14px">
                                Troubleshooting
                            </div>
                            <div v-for="(item, index) in site.lgSmart.troubleshooting" :key="index" class="v-flex pa-1" style="font-size: 14px">
                                <div style="min-width: 100px">
                                    {{ toDateString(item.date) }}
                                </div>
                                <div>
                                    {{ item.type.name }}
                                </div>
                            </div>
                        </div>
                    </v-menu>
                </div>

                <v-menu offset-y  v-if ="site.lgSmart && site.lgSmart.comment">
                    <template v-slot:activator="{ on, attrs }">
                        <a
                            v-bind="attrs"
                            v-on="on"
                        >
                            <div class="lgs-status-chip white--text warning mr-1">
                                Montage
                            </div>
                        </a>
                    </template>
                    <div class="lgs-comment">
                        {{ site.lgSmart.comment }}
                    </div>
                </v-menu>
            </div>
        </template>
    </f-title>
    <c-unit-lg-smart
        :site-id    = "site.id"
        :has-device = "!!site.deviceLGSmart"
    />
</div>
</template>

<script>
import CUnitLgSmart from "@/modules/msd/unit/components/controlls/CUnitLgSmart.vue";
import FTitle from "@/modules/core/components/utils/FTitle.vue";
import Core from "@/modules/core/service/Core";

export default {
    name: "CUnitLgSmartCard",
    components: {
        FTitle,
        CUnitLgSmart
    },

    props: {
        site: {

        }
    },

    methods: {
        toDateString (value) {
            return Core.format.date.display(value)
        }
    }
}
</script>

<style scoped>


.lgs-status-chip {
    border-style: solid;
    height: 21px;
    margin-bottom: 1px;
    text-align: center;
    border-radius: 4px;
    font-size: 13px;
    line-height: 15px;
    margin-top: 0px;
    margin-left: 4px;
}

.lgs-trouble-chip {
    border-style: solid;
    width: 200px;
    height:20px;
    margin-bottom: 1px;
    margin-top: 1px;
    text-align: center;
    border-radius: 4px;
    font-size: 13px;
    line-height: 15px;
}

.lgs-comment {
    background-color: white;
    font-size: 15px;
    width: 300px;
    padding: 8px;
}

</style>